import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, message: error && error.message };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      const message = this.state.message ? (
        <pre>{this.state.message}</pre>
      ) : null;
      return (
        <>
          <h1>Something went wrong.</h1>
          {message}
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;